export default {
	getMimeTypes: (state) => (fileTypeId) => {
    if (state?.dictionarySupportedFileTypes && fileTypeId) {
      if (Array.isArray(fileTypeId)) {
        return fileTypeId.reduce((acc, item) => {
          if (state.dictionarySupportedFileTypes[item]) acc = acc.concat(state.dictionarySupportedFileTypes[item])
          return acc
        }, []).join(", ")
      }
      else {
        return Array.isArray(state.dictionarySupportedFileTypes[fileTypeId]) ? state.dictionarySupportedFileTypes[fileTypeId].join(", ") : ""
      }
    } else return ""
  }
}
